var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb80 pt120"},[_c('div',{staticClass:"flex col-center row-column"},[_c('img',{attrs:{"src":_vm.imgD}}),_c('div',{staticClass:"back_btn pointer",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回列表")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }